import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CoSelfcheckAccountPage } from './co-selfcheck-account';
import { PipesModule } from '../../pipes/pipes.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { DirectivesModule } from '../../directives/directives.module';
import { ComponentsModule } from '../../components/components.module';
@NgModule({
  declarations: [
    CoSelfcheckAccountPage,
  ],
  imports: [
    IonicPageModule.forChild(CoSelfcheckAccountPage),
    DirectivesModule,
    PipesModule,
    NgxPaginationModule,
    ComponentsModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
]
})
export class CoSelfcheckAccountPageModule {}



// WEBPACK FOOTER //
// ./src/pages/co-selfcheck-account/co-selfcheck-account.module.ts